import { inject, provide, ref, type InjectionKey, type Ref } from 'vue';

// Narrow provide/inject pair holding only the drag preview element's DOM ref. Deliberately kept
// out of FileManagerDragState (useFileManagerDrag.ts) — that state is reactive drag *data*
// (draggedItems/dragOverPath), not DOM plumbing.
export type DragPreviewRefState = {
  previewEl: Ref<HTMLElement | null>;
};

export const dragPreviewRefKey: InjectionKey<DragPreviewRefState> = Symbol('dragPreviewRef');

export const provideDragPreviewRef = () => {
  const state: DragPreviewRefState = { previewEl: ref(null) };
  provide(dragPreviewRefKey, state);
  return state;
};

export const useDragPreviewRef = () => {
  const state = inject(dragPreviewRefKey);
  if (!state) {
    throw new Error(
      'useDragPreviewRef() must be called within a component tree provided by provideDragPreviewRef()',
    );
  }
  return state;
};
